import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { useI18n } from '../i18n/index.jsx';

/**
 * SB-9832 — the public disclosure slot on a speaker card.
 *
 * The API attaches `speaker.disclosure` only when the organization has
 * Disclosures on AND "Show in embeds" enabled, and only for a current
 * attestation. The payload is entity + nature, never amounts or free text —
 * this component just renders what it gets and shows nothing otherwise.
 *
 * @param {{ disclosure?: { attested_at?: string|null, relationships?: Array<{entity_name: string, nature?: string|null}> } | null }} props
 */
export const hasDisclosure = disclosure =>
  !!disclosure && typeof disclosure === 'object' && Array.isArray(disclosure.relationships);

const SpeakerDisclosure = ({ disclosure, compact = false }) => {
  const { t } = useI18n();
  if (!hasDisclosure(disclosure)) return null;
  const rows = disclosure.relationships.filter(r => r && r.entity_name);
  const summary = rows.length === 0 ? t('disclosure_none') : t.plural('disclosure_count', rows.length);

  return (
    <div className={`session-modal__disclosure${compact ? ' session-modal__disclosure--compact' : ''}`}>
      <p className="session-modal__disclosure-summary">
        <ShieldCheck size={14} aria-hidden="true" />
        <span>{summary}</span>
      </p>
      {rows.length > 0 && (
        <ul className="session-modal__disclosure-list" aria-label={t('disclosure_list_label')}>
          {rows.map((r, i) => (
            <li key={`${r.entity_name}-${i}`} className="session-modal__disclosure-item">
              <span className="session-modal__disclosure-entity">{r.entity_name}</span>
              {r.nature ? <span className="session-modal__disclosure-nature"> · {r.nature}</span> : null}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SpeakerDisclosure;
